// Caption TikTok (2026-10-16). Dulu caption TikTok = judul video saja. Kosong = tetap pakai judul.
// Caption bisa diedit lagi dari Riwayat job selama posting TikTok-nya belum terkirim
// (PUT /api/jobs/:id/tiktok-caption) — worker & scheduler membaca ulang caption tepat sebelum posting.
import React, { useState } from 'react';
import axios from 'axios';
import { colors, radius } from '../theme';

const API = process.env.REACT_APP_API_URL || 'https://api.starhubcreative.id';
export const TT_CAPTION_MAX = 2200;

const areaStyle = { width: '100%', minHeight: 80, background: colors.bgCardMuted, border: `1px solid ${colors.border}`, borderRadius: 8,
  color: colors.textPrimary, padding: '8px 12px', fontSize: 13, resize: 'vertical', boxSizing: 'border-box', fontFamily: 'inherit' };

/** Caption yang benar-benar akan diposting (dipakai juga untuk pratinjau TikTok). */
export function captionEfektif(caption, title) {
  return String(caption || '').trim() || title || '';
}

export default function TiktokCaptionField({ value, onChange, title, aiGenerated }) {
  return (
    <div style={{ marginBottom: 12 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6, gap: 8 }}>
        <label style={{ fontSize: 13, color: colors.textSecondary }}>Caption TikTok</label>
        <span style={{ fontSize: 11, color: aiGenerated ? '#10b981' : colors.textMuted }}>
          {aiGenerated ? '✨ AI generated · ' : ''}{value.length}/{TT_CAPTION_MAX}
        </span>
      </div>
      <textarea placeholder={title ? `Kosongkan untuk memakai judul: "${title.slice(0, 60)}"` : 'Caption + hashtag untuk TikTok...'}
        value={value} maxLength={TT_CAPTION_MAX} onChange={e => onChange(e.target.value)} style={areaStyle} />
      <div style={{ fontSize: 11, color: colors.textSecondary, marginTop: 4, lineHeight: 1.5 }}>
        💡 Sertakan 3–5 hashtag (#koplo #fyp). Masih bisa diubah dari Riwayat job selama belum terposting ke TikTok.
      </div>
    </div>
  );
}

/** Boleh edit caption: job ke TikTok yang posting TikTok-nya belum terkirim. */
export function bisaEditCaptionTiktok(job) {
  if (job.platforms !== 'tiktok' && job.platforms !== 'all') return false;
  return ['awaiting_approval', 'pending', 'processing'].includes(job.status) || ['pending', 'scheduled'].includes(job.tiktok_status);
}

export function EditCaptionTiktok({ job, onSaved }) {
  const [open, setOpen] = useState(false);
  const [val, setVal] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  const buka = () => { setVal(job.tiktok_caption || ''); setErr(''); setOpen(true); };
  async function simpan() {
    setBusy(true); setErr('');
    try {
      const r = await axios.put(`${API}/api/jobs/${job.id}/tiktok-caption`, { tiktok_caption: val });
      onSaved(r.data.tiktok_caption);
      setOpen(false);
    } catch (e) {
      setErr(e.response?.data?.error || 'Gagal menyimpan caption');
    }
    setBusy(false);
  }

  return (
    <>
      <button type="button" onClick={buka} title="Edit caption TikTok sebelum terposting"
        style={{ display: 'block', marginTop: 4, padding: '2px 8px', fontSize: 11, borderRadius: 6, cursor: 'pointer',
          border: `1px solid ${colors.border}`, background: 'transparent', color: colors.textSecondary, whiteSpace: 'nowrap' }}>✏️ Caption</button>
      {open && (
        <div onClick={e => { if (e.target === e.currentTarget && !busy) setOpen(false); }}
          style={{ position: 'fixed', inset: 0, zIndex: 1000, background: 'rgba(17,24,39,0.55)', overflowY: 'auto', padding: '24px 16px' }}>
          <div style={{ maxWidth: 520, margin: '40px auto', background: colors.bgCard, borderRadius: radius.lg, padding: 20, boxSizing: 'border-box' }}>
            <h3 style={{ margin: '0 0 4px', fontSize: 15, color: colors.textPrimary }}>Edit caption TikTok</h3>
            <div style={{ fontSize: 12, color: colors.textSecondary, marginBottom: 12, overflowWrap: 'anywhere' }}>{job.title || 'Tanpa judul'}</div>
            <TiktokCaptionField value={val} onChange={setVal} title={job.title} />
            <div style={{ fontSize: 12, color: colors.textSecondary, marginBottom: 6 }}>Akan diposting sebagai:</div>
            <div style={{ fontSize: 12, color: colors.textPrimary, background: colors.bgCardMuted, borderRadius: 8, padding: '8px 12px', whiteSpace: 'pre-wrap', overflowWrap: 'anywhere', marginBottom: 12, maxHeight: 160, overflowY: 'auto' }}>
              {captionEfektif(val, job.title) || '(kosong)'}
            </div>
            {err && <div style={{ fontSize: 12, color: colors.danger, marginBottom: 10 }}>{err}</div>}
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              <button type="button" className="btn btn-primary" disabled={busy} onClick={simpan}>{busy ? 'Menyimpan...' : 'Simpan caption'}</button>
              <button type="button" className="btn btn-outline" disabled={busy} onClick={() => setOpen(false)}>Batal</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
